import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'tt_signup_promo_dismissed';

/**
 * Promo modal. Caller decides WHEN to open it (e.g. on idle); this component
 * just renders, animates, and remembers dismissal for the rest of the session.
 */
export default function SignupPromoModal({ open }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    setVisible(true);
  }, [open]);

  const close = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4 bg-black/50 backdrop-blur-sm animate-[fadeIn_180ms_ease-out]"
      onClick={close}
      role="dialog"
      aria-modal="true"
      aria-labelledby="signup-promo-title"
    >
      <div
        className="relative max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden animate-[popIn_220ms_cubic-bezier(0.34,1.56,0.64,1)]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Small close button */}
        <button
          onClick={close}
          aria-label="Close"
          className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors text-lg leading-none"
        >
          ×
        </button>

        {/* Gradient header */}
        <div className="bg-gradient-to-br from-tea-600 via-tea-700 to-blue-800 px-6 pt-8 pb-6 text-center text-white">
          <div className="inline-block bg-amber-300 text-amber-900 text-[11px] font-bold uppercase tracking-wider rounded-full px-3 py-1 mb-3">
            New customer offer
          </div>
          <div className="text-5xl font-extrabold tracking-tight leading-none">
            15<span className="text-3xl align-top">%</span> OFF
          </div>
          <p className="mt-2 text-tea-50 text-sm font-medium">
            your first order when you create a free account
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <h2 id="signup-promo-title" className="text-lg font-bold text-gray-900 text-center">
            Plus an exclusive head start
          </h2>

          <div className="mt-4 flex items-start gap-3 rounded-lg bg-amber-50 border border-amber-200 px-4 py-3">
            <span aria-hidden="true" className="text-xl leading-none">⚡</span>
            <p className="text-sm text-amber-900 leading-snug">
              Create your free account in under a minute and your{' '}
              <strong>15% discount</strong> is applied automatically at checkout.
            </p>
          </div>

          <Link
            to="/register"
            onClick={close}
            className="mt-5 block w-full text-center btn-primary py-3 text-sm font-semibold"
          >
            Claim my 15% off
          </Link>

          <button
            onClick={close}
            className="mt-2 block w-full text-center text-xs text-gray-500 hover:text-gray-700 py-1"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
